import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { Field, getFormSyncErrors, getFormValues, reduxForm, touch } from 'redux-form/lib/immutable';
import Button from '../../shared/form/_Button';
import { sendRecommendOfficeEmail } from '../../../actions/recommendOfficeActions';
import Immutable from 'immutable';
import { validate } from '../../../lib/validators/recommendOfficeValidator';
import Error from '../../shared/form/_Error';
import repTrade from '../../../assets/images/rep-trade.png';

// constants
const FORM_NAME = 'recommendOffice';

class RecommendOffice extends Component {
    _handleSubmit = (e) => {
      e.preventDefault();
      const { recommendOfficeEmailSend, formValues, anyTouched, formTouch, valid } = this.props;

      if (!anyTouched) {
        formTouch();
      }

      if (!valid) {
        return;
      }

      const email = formValues.get('email');

      recommendOfficeEmailSend({ email });
    };

    render() {
      const { anyTouched, formSyncErrors, formValues } = this.props;
      const errors = anyTouched ? formSyncErrors : Immutable.Map();

      return (
        <div>
          <div className='recommend-form__header'>
                If you love our product/service share it with other offices.
            <span className={ 'recommend-form__header--indicated' }> <br /> If they sign up the referral bonus is yours!
              <i className={ 'fa fa-dollar recommend-form__icon' } />
            </span>
          </div>
          <div className='recommend-list__container'>
            <div className='recommend-list__header'>Help other improve their office experience</div>
            <ul>
              <li>Keep their waiting rooms free for patients.</li>
              <li>Reduce unscheduled interruptions.</li>
              <li>Let medical staff focus on patients. Open Books MD will organize reps.</li>
            </ul>
          </div>
          <form className={ 'recommend-form' } noValidate onSubmit={ this._handleSubmit }>

            <Field className='form__field form__field--rounded'
              component='input'
              name='email'
              placeholder='Enter an email'
              type='email'
              value={ formValues.get('email') } />
            <Error>{errors.get('email')}</Error>
            <Button className='form__button form__button--green recommend-form__button'>
                Send an email
            </Button>
          </form>
          <div className={ 'recommend-form__image-wrapper' }>
            <img className={ 'recommend-form__image' } src={ repTrade } />
          </div>
        </div>

      );
    }
}

RecommendOffice.propTypes = {
  anyTouched: PropTypes.bool.isRequired,
  formSyncErrors: PropTypes.instanceOf(Immutable.Map),
  formTouch: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Immutable.Map),
  recommendOfficeEmailSend: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(FORM_NAME)(state) || Immutable.Map(),
    formSyncErrors:  Immutable.Map(getFormSyncErrors(FORM_NAME)(state)) || Immutable.Map()
  };
};

const mapDispatchToProps = ({
  recommendOfficeEmailSend: (email) => sendRecommendOfficeEmail(email),
  formTouch: () => touch(FORM_NAME)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
    {
      form: FORM_NAME,
      touchOnBlur: false,
      validate
    }
  )(RecommendOffice));



// WEBPACK FOOTER //
// ./app/components/managers/recommendOffice/RecommendOffice.jsx